import { render, staticRenderFns } from "./pensionesCobrar.vue?vue&type=template&id=ffc1df34&scoped=true"
import script from "./pensionesCobrar.vue?vue&type=script&lang=js"
export * from "./pensionesCobrar.vue?vue&type=script&lang=js"
import style0 from "./pensionesCobrar.vue?vue&type=style&index=0&id=ffc1df34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc1df34",
  null
  
)

export default component.exports